import React, {useRef} from 'react'
import './step4.css'
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { Button } from 'primereact/button'; 
import { Link } from "react-router-dom";
import Office from '../../Articles/Office';
const Step4 = () => {
   const stepperRef = useRef(null);
      const step1Ref = useRef(null);  // Add this ref for the container


  return (
    <div className='step1' ref={step1Ref}>
                <div className='stepchat'>
                    <Link to={'/chatbot'} ><Button style={{fontWeight:"500"}} className='buttonChat' squared>
                       <span>Talk to our chat</span> <img className='chatbotIcon' src={`${process.env.PUBLIC_URL}/Images/chatboticon.png`} alt="Chatbot Icon" /></Button></Link>
                </div>
              <h1 className='stepnumber'>STEP 4</h1>
              <h1 className='stepname'>Business Location and Start Operations</h1>
              <div className="card p-0 w-full flex justify-content-center">
                <Stepper ref={stepperRef} >
                    <StepperPanel header="Office Workspace and Start Operations">
                        <div className="surface-ground flex flex-column h-full">
                            <div className="p-0 flex-auto flex flex-column align-items-start font-medium">
                           <Office />
                            </div>
                        </div>
                        
                    </StepperPanel>
                </Stepper>
            </div>
        
            </div>
  )
}

export default Step4